import { hideWhenReadOnlyRule } from '../commonRules';
export const CompareButton = {
    key: 'compare',
    buttonStyle: 'default-1',
    icon: 'columns',
    section: 'middle',
    prio: 3,
    text: 'Jämför',
    defaultRules: [
        hideWhenReadOnlyRule,
        {
            id: 'hideWhenComparePermissionMissing',
            description: 'Knappen är dold när användaren saknar behörighet att jämföra.',
            evaluateState: (row, inca)=>{
                if (!inca.form.designedForm.userHasPermissionToCompare) {
                    return {
                        state: 'Hidden'
                    };
                }
                return {
                    state: 'Visible'
                };
            }
        }
    ],
    onClick: async (row, inca)=>{
        await inca.errand.compare();
    }
};
